import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent {
  @Input() files: File[] = [];
  @Input() multipleSelection: boolean;
  @Input() maxFileSize = 104857600;
  @Input() maxFileNameLength = 100;
  @Output() changeInputValue: EventEmitter<File[]> = new EventEmitter();

  accetable = '';
  uploadBoxVisible = true;

  @Input() set extensions(value: string[]) {
    this.accetable = value.join(', ');
  }

  errorMessage = '';

  onUploadFile({ target }: any): void {
    this.errorMessage = '';
    const inputFiles = [...target.files];
    const currentFile = target.files[target.files.length - 1];
    const isSizeAllowed = currentFile.size > this.maxFileSize;
    const isExtensionAllowed = this.checkExtensionDisallowed(currentFile.name);

    const isNameAllowed = currentFile.name.length > this.maxFileNameLength;
    if (isSizeAllowed || isNameAllowed || isExtensionAllowed) {
      if (isNameAllowed) {
        this.errorMessage = `${$localize`Maksymalna długość nazwy pliku to`} ${
          this.maxFileNameLength
        } ${$localize`znaków.`}`;
      } else if (isSizeAllowed) {
        this.errorMessage = $localize`Maksymalny rozmiar pliku to ${(this.maxFileSize / 1048576)
          .toFixed(2)
          .replace('.', ',')} MB.`;
      } else if (isExtensionAllowed) {
        this.errorMessage = $localize`Wybrano nieprawidłowe rozszerzenie pliku.`;
      }
      const dt = new DataTransfer();
      for (let i = 0; i < inputFiles.length; i++) {
        const file = inputFiles[i];
        if (inputFiles.length - 1 !== i) {
          dt.items.add(file);
        }
      }
      target.files = dt.files;
    } else if (this.checkFiles(inputFiles)) {
      const files = [...this.files, ...inputFiles];
      this.handleFileInputChange(files);
    }
    target.value = '';
  }

  deleteFile(index: number): void {
    const files = [...this.files];
    files.splice(index, 1);
    this.handleFileInputChange(files);
  }

  trackByFn(index: number, { a = {} }: Record<string, unknown>): number {
    return index;
  }

  private checkExtensionDisallowed(fielName: string): boolean {
    if (this.accetable) {
      const fileExtension = fielName.substring(fielName.indexOf('.'));
      const extensionsAllowedArr = this.accetable.split(',');
      return extensionsAllowedArr.some((el) => el !== fileExtension);
    }
    return false;
  }

  private checkFiles(files: File[]): boolean {
    return files.length && !this.containsDuplicates(files) && this.checkIsEmpty(files);
  }

  private checkIsEmpty(files: File[]): boolean {
    const fileSizeState = Boolean(files.filter((file) => file.size > 0).length);
    if (!fileSizeState) {
      this.errorMessage = $localize`Plik nie może być pusty`;
    }
    return fileSizeState;
  }

  private containsDuplicates(files: File[]): boolean {
    const hasDuplicates = new Set(files.map((f) => f.name)).size !== files.length;

    if (hasDuplicates) {
      this.errorMessage = $localize`Plik o takiej samej nazwie już istnieje`;
    }
    return hasDuplicates;
  }

  private handleFileInputChange(files: File[]): void {
    this.changeInputValue.emit(files);
    if (!this.multipleSelection) {
      this.uploadBoxVisible = !files.length;
    }
  }
}
